import { render, staticRenderFns } from "./bgComp.vue?vue&type=template&id=fb491c80&scoped=true"
import script from "./bgComp.vue?vue&type=script&lang=ts"
export * from "./bgComp.vue?vue&type=script&lang=ts"
import style0 from "./bgComp.vue?vue&type=style&index=0&id=fb491c80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb491c80",
  null
  
)

export default component.exports